export default class tController {
  constructor(game, activate) {
    this.game = game;

    this.bindedHandleWindowResize = this.handleWindowResize.bind(this);
    this.bindedWindowBlur = this.handleWindowBlur.bind(this);
    this.bindedWindowFocus = this.handleWindowFocus.bind(this);
    this.bindedVisibilityChange = this.handleVisibilityChange.bind(this);

    if (activate) {
      this.activate();
    }
  }

  activate() {
    window.addEventListener('resize', this.bindedHandleWindowResize);

    if (__ENV_IS_BBC__) {
      console.log('add blur listener');
      window.addEventListener('blur', this.bindedWindowBlur);
      window.addEventListener('focus', this.bindedWindowFocus);
      window.addEventListener('visibilitychange', this.bindedVisibilityChange);
    }
  }

  deactivate() {
    window.removeEventListener('resize', this.bindedHandleWindowResize);
    window.removeEventListener('blur', this.bindedWindowBlur);
    window.removeEventListener('focus', this.bindedWindowFocus);
    window.removeEventListener('visibilitychange', this.bindedVisibilityChange);
  }

  handleWindowBlur() {
    // switch (this.state.current) {
    // }
  }

  handleWindowFocus() {
    // switch (this.state.current) {
    // }
  }

  handleVisibilityChange() {
    // if (document.visibilityState === 'hidden') {
    //         s.bindedWindowBlur();
    //     }
    //     else {
    //         s.bindedWindowFocus();
    //     }
  }

  handleWindowResize() {
    this.game.aspectController.updateGameSize();
  }
}



// WEBPACK FOOTER //
// ./js/app/controller/WindowEventController.js